<template>
	<div class='add-plot'>

		<div class='flex-container'>
			<div v-if='lpo.inspection_type_id === "4"'>
				<span class='label'>Радиус, м</span>
				<custom-p-select
					v-model='radius'
					:options='circle_r'
					:optionLabel='null'
					:dataKey='null'
				/>
			</div>

			<div>
				<span class='coord-input-lat'>Широта</span>
				<input class='coord-input-lat' v-model='centerPoint.lat' type='number'>
			</div>
			<div>
				
				<span class='coord-input-lon'>Долгота</span>
				<input class='coord-input-lon' v-model='centerPoint.lon' type='number'>

			</div>

			<div v-if='lpo.inspection_type_id === "2"'>
				<span class='label'>Угол наклона</span>
				<custom-p-select
					v-model='radius'
					:options='info_slope_angle'
					:optionLabel='"slope_angle"'
				/>
			</div>

		</div>

			<div class='btn-row'>
				<button @click='close' class='add-btn'>Закрыть</button>
				<button @click='save' class='add-btn'>Добавить</button>
			</div>



	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex';

	export default {
		name: 'TypeStripAddPlot',
		data() {
			return {
				radius: null,
				centerPoint: { lat: null, lon: null },
			};
		},
		computed: {
			lpo() {
				return this.$store.state.selectedLpo.lpo;
			},
			circle_r() {
				return this.$store.state.selectedLpo.recount.circleR;
			},

			...mapState({
				info_slope_angle: state => state.catalogs.info_slope_angle
			})
		},
		methods: {
			save() {
				if ( (this.radius === null || this.radius === '')) {

					if (this.lpo.inspection_type_id === '2') {
						this.$toast.add({severity: 'warn', detail: `Необходимо указать угол наклона`, life: 5000});
					}

					if (this.lpo.inspection_type_id === '4') {
						this.$toast.add({severity: 'warn', detail: `Необходимо указать радиус`, life: 5000});
					}

					return;
				}

				if (this.centerPoint.lat === null || this.centerPoint.lat === '' ||
						this.centerPoint.lon === null || this.centerPoint.lon === '') {
					console.log('no center point');
					this.$toast.add({severity: 'warn', detail: `Необходимо указать координаты`, life: 5000});
					return;
				}

				const temp = {
					lpo: this.lpo,
					width: this.radius,
					pointList: [ this.centerPoint ]
				};

				this.addPlot(temp).then(res => {
					this.updatePlotList(this.lpo.lpo_id).then(res => {
						this.getCircleR();
					});
				});

			},
			close() {
				this.$emit('close');
			},

			...mapActions('selectedLpo/recount', [
				'addPlot',
				'updatePlotList',
				'getCircleR',
			])
		},

		created() {
		
			if (this.lpo.inspection_type_id === '4') {
				this.getCircleR();
			} else if (this.lpo.inspection_type_id === '2') {

				const catalogs = [ 'info_slope_angle' ];
				this.$store.dispatch('loadCatalogs', catalogs);
			}
		},
	};
</script>

<style scoped src='@/style/flex.css'></style>

<style scoped>
	.flex-container {
		gap: 20px;
	}

	.btn-row {
		margin-top: 10px;
	}
	.btn-row > button:first-child {
		margin-right: 10px;
	}

	.add-plot {
		background-color: #eee;
		border: 1px solid black;
		padding: 20px;
		/*width: 350px;*/
		max-width: 700px;
	}

	.grid {
		display: grid;
		grid-template-columns: [label] auto [input-lat] 1fr [input-lon] 1fr [turning-btn] auto;
		grid-gap: 4px;
	}

	.turning-points-block {
		grid-column: span 3;
	}

	.label {
		grid-column: label;
		grid-row: auto;
	}
	.width-input {
		grid-column: span 2;
	}
	.coord-input-lat {
		grid-column: input-lat;
		grid-row: auto;
	}
	.coord-input-lon {
		grid-column: input-lon;
		grid-row: auto;
	}
	.add-btn {
		grid-column: span 3;
	}
</style>